import { HTTP } from '@/services/http'
import { Settings } from '@/settings'

export class LogService extends HTTP {
	constructor() {
		super(Settings.API_BASE_URL)
	}

	async upload(logs) {
		return await super.post('/uploadlogs', {
			logs,
			user_agent: navigator.userAgent,
		}, true)
	}
}